/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_1_ResultInputs */

const et_portfolio_project_1_result = /** @type {(inputs: Portfolio_Project_1_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutasime Google top 3 positsiooni 90 päevaga, sissetulevad päringud kasvasid 3x.`)
};

const en_portfolio_project_1_result = /** @type {(inputs: Portfolio_Project_1_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reached top 3 Google rankings in 90 days, increasing inbound inquiries by 3x.`)
};

/**
* | output |
* | --- |
* | "Reached top 3 Google rankings in 90 days, increasing inbound inquiries by 3x." |
*
* @param {Portfolio_Project_1_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_1_result = /** @type {((inputs?: Portfolio_Project_1_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_1_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_1_result(inputs)
	return en_portfolio_project_1_result(inputs)
});